import { NgModule } from '@angular/core'
import { StoreModule } from '@ngrx/store'
import { StoreKeysEnum } from '../../../../store/store-keys'
import { concernedViewReducer } from './concerned-view.reducer'

@NgModule({
    imports: [
        StoreModule.forFeature(StoreKeysEnum.ConcernedView, concernedViewReducer),
    ],
})
export class ConcernedViewStateModule {}
